import Vector2D from "./Vector2D";
import * as WGS84Util from "@/utils/WGS84Util";

export default class Location {
  constructor(latitude, longitude) {
    this._latitude = latitude;
    this._longitude = longitude;
  }

  toMercatorAtlasPosition() {
    return new Vector2D(
      (WGS84Util.SEMI_MAJOR_AXIS * Math.PI * this.longitude) / 180.0,
      WGS84Util.SEMI_MINOR_AXIS *
        Math.log(
          (1.0 + Math.sin((Math.PI * this.latitude) / 180.0)) /
            Math.cos((Math.PI * this.latitude) / 180.0)
        )
    );
  }

  get latitude() {
    return this._latitude;
  }

  get longitude() {
    return this._longitude;
  }
}
